import { ENDPOINTS, SOCKET_BASE_URL } from "../constants/urls";

const URL = ENDPOINTS.SOCKET_URL;
const paymentSocketUrl = ENDPOINTS.PAYMENT_STATUS_SOCKET;
export const connectSocket = (id, blogId) => {
  return new WebSocket(
    `${SOCKET_BASE_URL.SOCKET_BASE_URL}${URL}?uniqueId=${id}&blogId=${blogId}`
  );
};
export const connectPaymentStatusSocket = (id) => {
  try {
    return new WebSocket(
      `${SOCKET_BASE_URL.SOCKET_BASE_URL}${paymentSocketUrl}?uniqueId=${id}`
    );
  } catch (err) {
    return null;
  }
};
